import React from 'react';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import PremiumIcon from '@wix/da-ds/pkg/Icons/PremiumFolder';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';
var SubscriberStat = function (_a) {
    var deviation = _a.deviation, onlyNumbers = _a.onlyNumbers, className = _a.className;
    var _b = useDeviationStats(deviation), subscribers = _b.subscribers, isSubscribable = _b.isSubscribable, isInSubscription = _b.isInSubscription;
    var isTierRelated = isSubscribable || isInSubscription;
    var isShown = isTierRelated && subscribers !== undefined;
    return isShown ? (React.createElement(Stat, { className: className, deviation: deviation, icon: PremiumIcon, statNameLocaleKey: "deviation.stats.subscribers", statCount: subscribers, onlyNumbers: onlyNumbers, biData: BiData({
            evid: 2,
            click_info: 'subscribers',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
        }) })) : null;
};
SubscriberStat.displayName = 'ViewStat';
export default SubscriberStat;
//# sourceMappingURL=SubscriberStat.js.map